import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';

const TooltipDismissable = ({tag, remove}) => (
  <span className="span1">
    <span className="span_main">
      <span className="span_text">
        {tag.name}
      </span>
      <IconButton
        edge="start"
        color="inherit"
        className="btn_less_margin"
        onClick={()=>remove(tag)}
      >
        <ClearIcon />
      </IconButton>
    </span>
  </span>
);

export default TooltipDismissable;
